import { render, staticRenderFns } from "./FlexiquoteModuleSideMenu.vue?vue&type=template&id=f0186738"
import script from "./FlexiquoteModuleSideMenu.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0186738')) {
      api.createRecord('f0186738', component.options)
    } else {
      api.reload('f0186738', component.options)
    }
    module.hot.accept("./FlexiquoteModuleSideMenu.vue?vue&type=template&id=f0186738", function () {
      api.rerender('f0186738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/flexiquotemodule/FlexiquoteModuleSideMenu.vue"
export default component.exports